class ProductInfoAccordion extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('.product-info-accordion__item');
    this.drawer = document.querySelector('product-info-drawer');

    if (!this.drawer) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        this.drawer.open(button.dataset.tab);
        this.scrollTabIntoView(button.dataset.tab);
      });
    });
  }

  /**
   * Scrolls the corresponding tab into view inside the drawer's
   * horizontally-scrolling tab strip. Uses 'nearest' on both axes so it
   * never triggers a vertical page scroll — only the tab strip moves.
   * @param {string} tabName
   */
  scrollTabIntoView(tabName) {
    const tabsNav = this.drawer.querySelector('.product-info-drawer__tabs');
    if (!tabsNav) return;

    const activeTab = tabsNav.querySelector(`[data-tab="${tabName}"]`);
    if (!activeTab) return;

    // Defer to the next frame in case open() triggers a class change
    // that affects layout (e.g. drawer becoming visible/display:block)
    // right before this runs — ensures scrollIntoView measures correctly.
    requestAnimationFrame(() => {
      activeTab.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    });
  }
}

if (!customElements.get('product-info-accordion')) {
  customElements.define('product-info-accordion', ProductInfoAccordion);
}